import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteMatchListPayload {
    data: {
        ids: string[]
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteMatchList = createSlice({
    name: 'matchList/delete',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteMatchListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteMatchListActions = deleteMatchList.actions
export default deleteMatchList.reducer
